import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { UserRole } from '@kennisbank/shared';
import { useAuth } from './AuthProvider.js';

/**
 * Frontend role gate. Defense in depth — the backend enforces RBAC
 * authoritatively (per A1 of /plan-eng-review, inline `req.auth.role` checks
 * on every admin route). This guard prevents the UI from even rendering an
 * admin-only page for the wrong role, so the admin doesn't waste a click and
 * a network round-trip discovering the 403.
 */
export function RoleGuard({
  allowed,
  children,
}: {
  allowed: UserRole[];
  children: ReactNode;
}): JSX.Element {
  const { user, loading } = useAuth();
  if (loading) return <></>;
  if (!user) return <Navigate to="/login" replace />;
  if (!allowed.includes(user.role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
